import Button from '../../buttons/Button';
import EmptyState from '../EmptyState';

export default function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <EmptyState icon="⚠️" title="Não foi possível carregar">
      <p>{(error as Error)?.message ?? 'Erro inesperado.'}</p>
      {onRetry && <div style={{ marginTop: 10 }}><Button size="sm" variant="ghost" onClick={onRetry}>Tentar novamente</Button></div>}
    </EmptyState>
  );
}
